var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuickbooks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 260.92 236.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2c9f1c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m139.98.14c13.59-1.58,26.46,10.46,26.58,24.74.16,18.33.04,36.66.04,54.99,0,26.98,0,53.97,0,81.5,19.92.45,40.2,3.47,55.45-13.62,12.46-13.97,15.55-30.1,7.88-47.28-7.66-17.15-21.68-25.48-40.41-25.88-2.97-.06-5.94,0-9.22,0,0-9.18,0-17.76,0-26.35,34.2-4.78,68.19,15.69,78.06,51.41,11.61,42.05-17.77,84.87-61.42,88.43-17.72,1.44-35.62.59-53.44.83-2.5.03-3.78-.85-3.53-3.48.06-.66,0-1.33,0-2,0-60.15,0-120.3,0-180.45,0-.82,0-1.65,0-2.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m80.3,161.64v26.97c-14.44.93-28.29-.44-40.92-7.15C11.66,166.73-2.22,143.38.29,112.01c2.3-28.75,18.1-48.79,44.75-59.63,6.79-2.76,14.48-4.25,21.82-4.51,17.63-.64,35.29-.21,53.36-.21v188.28c-9.57,1.96-21.67-6.23-24.95-17.38-.92-3.13-1.23-6.55-1.24-9.83-.08-42.81-.14-85.63.06-128.44.02-4.77-1.48-6.14-5.92-5.75-10.72.93-21.89.06-32.09,2.83-19.28,5.25-31.95,26.41-29.07,45.28,3.45,22.64,20.38,38.42,41.88,38.98,3.64.1,7.28.01,11.4.01Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickbooks);
export default __webpack_public_path__ + "static/media/quickbooks.de3077b5e9d194904d63634bf3e3fae8.svg";
export { ForwardRef as ReactComponent };